import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import page from 'page';
import { compose, withState, lifecycle, withProps } from 'recompose'
import { fetchingState } from '../../../helpers/hocs';
import { FormattedMessage, injectIntl } from 'react-intl';
import { get } from '../../../store/reducers/persons/info';
import { getIsLogged } from '../../../selectors/user';
import ApprovalForm from '../../../components/PersonProfile/Form/ApprovalForm';
import Overlay from '../../../components/Overlay';

//компонент документов для роли персоны, требует редиректа на главную страницу при разлогировании
const Documents = ({user, info, showFormEventPopup, setFormEventPopup}) => {
    return (!user && !user.person) ? null :(
        <div className='person-documents'>
            <div className='Container approval'>
                <h1 className='approval-title'>Согласие</h1>
                {(user.person && user.person.photos && user.person.photos.length > 0) && 
                    <div className='person-photos approval-photos'>
                        {user.person.photos.map((image, idx) =>
                            <div key={idx} className='person-photo'>
                                <img src={`${process.env.REACT_APP_HOST}files/${image._id}/image/`} />    
                            </div>
                        )}        
                    </div>
                }
                <div className='approval-text'>
                    Согласно ФЗ-152 мы обязаны получить согласие на обработку персональных данных и использование вашего 
                    изображения для публикации лота. Закон обязывает указывать паспортные данные. Мы постарались сделать 
                    процесс максимально удобным для вас, поэтому вам нужно всего лишь заполнить короткую анкету, 
                    форма согласия генерируется автоматически - вам нужно только распечатать её, подписать и вернуть нам
                    удобным вам способом (загрузить на сайт или отправить на почту нашим менеджерам).
                    {<span> Фото можно заменить на странице "Обо мне"</span>}
                </div>
                <div className='approval-form'>
                    <ApprovalForm person={user.person} showCompleteMessage={setFormEventPopup} photoProfile={(user.person && user.person.photos && user.person.photos.length > 0) ? user.person.photos[0]._id : null } />
                </div>
                <Overlay isActive={showFormEventPopup} onClose={()=> setFormEventPopup(false)} klassModifier='is--blured'>
                    {showFormEventPopup &&
                    <div className='SavePopup-data'>
                        <h1 className='EmailPopup-h1 EmailPopup-h1-connection'><FormattedMessage id='person_approval.request' /></h1>
                    </div>
                    }
                </Overlay>
            </div>
        </div> 
    )
}

const mapStateToProps = state => ({
    isLogged: getIsLogged(state),
})
  
const mapDispatchToProps = dispatch => bindActionCreators({ get }, dispatch)
  
const mergeProps = (state, {...dispatch}, props) => ({
    ...props,
    ...state,
})
  
export default injectIntl(compose(
    fetchingState({ multi: true }),
    withState('showFormEventPopup', 'setFormEventPopup', false),
    connect(mapStateToProps, mapDispatchToProps, mergeProps, state => ({currentLocale: state.intl.locale})),
    
    withProps(({ init, fetching, info }) => ({
        isExists: !init || (!fetching.info && init)
    })),
    lifecycle({
        componentWillReceiveProps (np) {
            if (this.props.isLogged && !np.isLogged) page('/')
        }
    })
)(Documents))



// WEBPACK FOOTER //
// ./src/containers/roles/person/Documents.jsx